import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-b815a712"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "时间 ", -1));
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "胜 ", -1));
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "平 ", -1));
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "负 ", -1));
const _hoisted_5 = {
  class: "contentWater"
};
const _hoisted_6 = {
  class: "contentWater"
};
const _hoisted_7 = {
  class: "contentWater"
};
const _hoisted_8 = {
  class: "contentWater"
};
const _hoisted_9 = {
  class: "contentWater"
};
const _hoisted_10 = {
  class: "contentWater"
};
const _hoisted_11 = {
  class: "contentWater"
};
const _hoisted_12 = {
  class: "contentWater"
};
const _hoisted_13 = {
  class: "contentWater"
};
const _hoisted_14 = {
  class: "contentWater"
};
const _hoisted_15 = {
  class: "contentWater"
};
const _hoisted_16 = {
  class: "contentWater"
};
const _hoisted_17 = {
  class: "contentWater"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "让胜 ", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "让平 ", -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "contentWater"
}, "让负 ", -1));
const _hoisted_21 = {
  class: "contentWater"
};
const _hoisted_22 = {
  class: "contentWater"
};
const _hoisted_23 = {
  class: "contentWater"
};
const _hoisted_24 = {
  class: "contentWater"
};
const _hoisted_25 = {
  class: "contentWater"
};
const _hoisted_26 = {
  class: "contentWater"
};
const _hoisted_27 = {
  class: "contentWater"
};
const _hoisted_28 = {
  class: "contentWater"
};
const _hoisted_29 = {
  class: "contentWater"
};
const _hoisted_30 = {
  class: "contentWater"
};
const _hoisted_31 = {
  class: "contentWater"
};
const _hoisted_32 = {
  class: "contentWater"
};
import { ref, nextTick } from 'vue';
import * as echarts from 'echarts';
import axios from 'axios';
import { decryptData } from './calculation.js';
export default {
  __name: 'HeatHadView',
  setup(__props, {
    expose: __expose
  }) {
    const chartContainer = ref(null);
    const chartContainer1 = ref(null);
    const chartContainer2 = ref(null);
    const chartContainer3 = ref(null);
    const chartContainer4 = ref(null);
    const divStyle = ref('display: none;'); // 初始样式设置div为可见
    const divStyle1 = ref('display: none;'); // 初始样式设置div为可见
    const divStyle2 = ref('display: none;'); // 初始样式设置div为可见
    const divStyle3 = ref('display: none;'); // 初始样式设置div为可见
    const divStyle4 = ref('display: none;'); // 初始样式设置div为可见
    const matchInfo = ref([]);
    const goalLine = ref("");
    const hadList = ref([{}]);
    const hhadList = ref([{}]);
    const hadFlag = ref(false);
    const hhadFlag = ref(false);
    const pushMatch = match => {
      hadFlag.value = false;
      hhadFlag.value = false;
      matchInfo.value = match;
      goalLine.value = match.hhadList[0].goalLine;
      hadList.value = match.hadList;
      hhadList.value = match.hhadList;
      let matchId = match.matchId;
      if (match.hadList.length > 0) {
        footBallRate(matchId);
        footBallRate2(matchId);
        footBallRate4(matchId, goalLine.value);
      }
      footBallRate1(matchId);
      footBallRate3(matchId);
    };
    const refreshHadList = () => {
      hadFlag.value = !hadFlag.value;
    };
    const refreshHHadList = () => {
      hhadFlag.value = !hhadFlag.value;
    };
    const footBallRate = async matchId => {
      try {
        const response = await axios.get('https://tuhaojie.asia/api-foot/supportRateV1/footBallRate?matchId=' + matchId + '&type=0');
        let data = response.data;
        if (data.data != null) {
          divStyle.value = 'display: block';
          const chart = echarts.init(chartContainer.value);
          const option = decryptData(data.data);
          chart.setOption(option);
        }
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };
    const footBallRate1 = async matchId => {
      try {
        const response = await axios.get('https://tuhaojie.asia/api-foot/supportRateV1/footBallRate?matchId=' + matchId + '&type=1');
        let data = response.data;
        if (data.data != null) {
          divStyle1.value = 'display: block';
          chartContainer1.value.display = 'block';
          const chart = echarts.init(chartContainer1.value);
          const option = decryptData(data.data);
          chart.setOption(option);
        }
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };
    const footBallRate2 = async matchId => {
      try {
        const response = await axios.get('https://tuhaojie.asia/api-foot/supportRateV1/footBallRate2?matchId=' + matchId + '&type=0');
        let data = response.data;
        if (data.data != null) {
          divStyle2.value = 'display: block';
          chartContainer2.value.display = 'block';
          const chart = echarts.init(chartContainer2.value);
          const option = decryptData(data.data);
          chart.setOption(option);
        }
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };
    const footBallRate3 = async matchId => {
      try {
        const response = await axios.get('https://tuhaojie.asia/api-foot/supportRateV1/footBallRate2?matchId=' + matchId + '&type=1');
        let data = response.data;
        if (data.data != null) {
          divStyle3.value = 'display: block';
          chartContainer3.value.display = 'block';
          const chart = echarts.init(chartContainer3.value);
          const option = decryptData(data.data);
          chart.setOption(option);
        }
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };
    const footBallRate4 = async (matchId, goalLine) => {
      try {
        const response = await axios.get('https://tuhaojie.asia/api-foot/supportRateV1/footBallRate3?matchId=' + matchId + '&goalLine=' + goalLine);
        let data = response.data;
        if (data.data != null) {
          divStyle4.value = 'display: block';
          chartContainer4.value.display = 'block';
          const chart = echarts.init(chartContainer4.value);
          const option = decryptData(data.data);
          // option.dataZoom = [{
          //   type: 'slider',
          //   filterMode: 'filter',
          //   xAxisIndex: 0,
          //   height: 15
          // }]
          console.log(option);
          chart.setOption(option);
        }
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };

    // 暴露给外部使用的函数
    __expose({
      pushMatch
    });
    return (_ctx, _cache) => {
      const _component_nut_divider = _resolveComponent("nut-divider");
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      const _component_var_col = _resolveComponent("var-col");
      const _component_var_row = _resolveComponent("var-row");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_nut_divider, {
        "content-position": "left"
      }, {
        default: _withCtx(() => [_createTextVNode("胜平负资金走势")]),
        _: 1
      }), _createElementVNode("div", {
        style: _normalizeStyle(divStyle.value)
      }, [_createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 9
        }, {
          default: _withCtx(() => [_hoisted_1]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_hoisted_3]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 9
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_5, "初" + _toDisplayString(hadList.value[0].updateDate) + " " + _toDisplayString(hadList.value[0].updateTime), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString(hadList.value[0].h), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_7, _toDisplayString(hadList.value[0].d), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString(hadList.value[0].a), 1)]),
          _: 1
        })]),
        _: 1
      }), hadFlag.value ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(hadList.value, (change, index) => {
        return _openBlock(), _createBlock(_component_nut_row, {
          key: index
        }, {
          default: _withCtx(() => [index != 0 && index != hadList.value.length - 1 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_nut_col, {
            span: 9
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_9, _toDisplayString(change.updateDate) + " " + _toDisplayString(change.updateTime), 1)]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_10, _toDisplayString(change.h), 1)]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_11, _toDisplayString(change.d), 1)]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_12, _toDisplayString(change.a), 1)]),
            _: 2
          }, 1024)], 64)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024);
      }), 128)) : _createCommentVNode("", true), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 9
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_13, "终" + _toDisplayString(hadList.value[hadList.value.length - 1].updateDate) + " " + _toDisplayString(hadList.value[hadList.value.length - 1].updateTime), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_14, _toDisplayString(hadList.value[hadList.value.length - 1].h), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_15, _toDisplayString(hadList.value[hadList.value.length - 1].d), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_16, _toDisplayString(hadList.value[hadList.value.length - 1].a), 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_var_row, null, {
        default: _withCtx(() => [_createVNode(_component_var_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "refresh",
            onClick: refreshHadList
          }, [!hadFlag.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode("点击加载更多历史数据")], 64)) : _createCommentVNode("", true), hadFlag.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode("点击收起历史数据")], 64)) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      })], 4), _createElementVNode("div", {
        ref_key: "chartContainer",
        ref: chartContainer,
        style: _normalizeStyle([{
          "width": "90vw",
          "height": "300px"
        }, divStyle.value])
      }, null, 4), _createElementVNode("div", {
        ref_key: "chartContainer2",
        ref: chartContainer2,
        style: _normalizeStyle([{
          "width": "90vw",
          "height": "300px"
        }, divStyle2.value])
      }, null, 4), _createVNode(_component_nut_divider, {
        "content-position": "left"
      }, {
        default: _withCtx(() => [_createTextVNode("让(" + _toDisplayString(goalLine.value) + ")胜平负资金走势", 1)]),
        _: 1
      }), _createElementVNode("div", {
        style: _normalizeStyle(divStyle1.value)
      }, [_createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 9
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_17, "让球（" + _toDisplayString(goalLine.value) + "） ", 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_hoisted_18]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_hoisted_19]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_hoisted_20]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 9
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_21, "初" + _toDisplayString(hhadList.value[0].updateDate) + " " + _toDisplayString(hhadList.value[0].updateTime), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_22, _toDisplayString(hhadList.value[0].h), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_23, _toDisplayString(hhadList.value[0].d), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_24, _toDisplayString(hhadList.value[0].a), 1)]),
          _: 1
        })]),
        _: 1
      }), hhadFlag.value ? (_openBlock(true), _createElementBlock(_Fragment, {
        key: 0
      }, _renderList(hhadList.value, (change, index) => {
        return _openBlock(), _createBlock(_component_nut_row, {
          key: index
        }, {
          default: _withCtx(() => [index != 0 && index != hhadList.value.length - 1 ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createVNode(_component_nut_col, {
            span: 9
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_25, _toDisplayString(change.updateDate) + " " + _toDisplayString(change.updateTime), 1)]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_26, _toDisplayString(change.h), 1)]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_27, _toDisplayString(change.d), 1)]),
            _: 2
          }, 1024), _createVNode(_component_nut_col, {
            span: 5
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_28, _toDisplayString(change.a), 1)]),
            _: 2
          }, 1024)], 64)) : _createCommentVNode("", true)]),
          _: 2
        }, 1024);
      }), 128)) : _createCommentVNode("", true), _createVNode(_component_nut_row, null, {
        default: _withCtx(() => [_createVNode(_component_nut_col, {
          span: 9
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_29, "终" + _toDisplayString(hhadList.value[hhadList.value.length - 1].updateDate) + " " + _toDisplayString(hhadList.value[hhadList.value.length - 1].updateTime), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_30, _toDisplayString(hhadList.value[hhadList.value.length - 1].h), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_31, _toDisplayString(hhadList.value[hhadList.value.length - 1].d), 1)]),
          _: 1
        }), _createVNode(_component_nut_col, {
          span: 5
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_32, _toDisplayString(hhadList.value[hhadList.value.length - 1].a), 1)]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_var_row, null, {
        default: _withCtx(() => [_createVNode(_component_var_col, {
          span: 24
        }, {
          default: _withCtx(() => [_createElementVNode("div", {
            class: "refresh",
            onClick: refreshHHadList
          }, [!hhadFlag.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 0
          }, [_createTextVNode("点击加载更多历史数据")], 64)) : _createCommentVNode("", true), hhadFlag.value ? (_openBlock(), _createElementBlock(_Fragment, {
            key: 1
          }, [_createTextVNode("点击收起历史数据")], 64)) : _createCommentVNode("", true)])]),
          _: 1
        })]),
        _: 1
      })], 4), _createElementVNode("div", {
        ref_key: "chartContainer1",
        ref: chartContainer1,
        style: _normalizeStyle([{
          "width": "90vw",
          "height": "300px"
        }, divStyle1.value])
      }, null, 4), _createElementVNode("div", {
        ref_key: "chartContainer3",
        ref: chartContainer3,
        style: _normalizeStyle([{
          "width": "90vw",
          "height": "300px"
        }, divStyle3.value])
      }, null, 4), _createVNode(_component_nut_divider, {
        "content-position": "left"
      }, {
        default: _withCtx(() => [_createTextVNode("总资金走势")]),
        _: 1
      }), _createElementVNode("div", {
        ref_key: "chartContainer4",
        ref: chartContainer4,
        style: _normalizeStyle([{
          "width": "90vw",
          "height": "300px"
        }, divStyle4.value])
      }, null, 4)], 64);
    };
  }
};